import gql from 'graphql-tag';

const getExplanationVideoQuery = gql`
  query getExplanationVideo($organisationId: String!, $bucketKey: String!) {
    getS3SignedUrl(organisationId: $organisationId, bucketKey: $bucketKey, action: get)
  }
`;

const getExplanationVideoUrl = (organisationId, videoName) => ({
  query: getExplanationVideoQuery,
  module: 'assets',
  ignoreCache: true,
  buildVariables: () => ({
    organisationId,
    bucketKey: `global/video/${videoName}.mp4`
  })
});

export default getExplanationVideoUrl;